module.exports = __webpack_public_path__ + "assets/invitation-code-no-bg.1dc6d382.svg";